import Action from '@/services/Action/Action';
import * as types from '../mutation-types';
import Vue from 'vue';
import { forEach } from 'lodash';

// state
export const state = {
  unassigned: null,
  pending: null,
  noAccess: null,
  updates: null,
};

// mutations
export const mutations = {
  [types.FETCH_COUNTS_FAILURE](state) {
    state = {
      unassigned: null,
      pending: null,
      noAccess: null,
      updates: null,
    };
  },

  [types.FETCHING_COUNTS](state) {},

  [types.FETCH_COUNTS_SUCCESS](state, counts) {
    forEach(state, (value, key) => {
      Vue.delete(state, key);
    });

    forEach(counts, (value, key) => {
      Vue.delete(state, key);
      Vue.set(state, key, value);
    });
  },

  [types.RESET_COUNTS](state) {
    forEach(state, (value, key) => {
      Vue.delete(state, key);
    });
  },
};

// actions
export const actions = {
  /**
   * @param commit
   * @param rootState
   * @param assessmentTypeId
   * @returns {Promise<void>}
   */
  async refreshCounts({ commit, rootState }, assessmentTypeId) {
    commit(types.FETCHING_COUNTS);

    let typeId = assessmentTypeId;

    if (!assessmentTypeId && rootState.assessmentType && rootState.assessmentType.assessmentTypeId) {
      typeId = rootState.assessmentType.assessmentTypeId;
    }

    let tenure = rootState.propertyTenure.propertyTenure;
    if (!tenure) {
      tenure = 'All Tenures';
    }

    try {
      const response = await Action.getCounts(typeId, tenure);
      commit(types.FETCH_COUNTS_SUCCESS, response.data.data);
    } catch (e) {
      commit(types.FETCH_COUNTS_FAILURE);
    }
  },
};

// getters
export const getters = {
  count: state => status => state[status],
  counts: state => state,
};
